


















































































































import { Component, Vue } from 'vue-property-decorator';
import { JobSearchTeam } from '@/@types/LibraryComponent';

@Component
export default class JobSearchTermsModule extends Vue {
  private savedTerms: Array<JobSearchTeam> = require('@/repository/mock/dummyData/job/savedTerms.json').savedTerms;
  private searchTerms: Array<string> = [
    'javascript',
    'Vue.js',
    'AWS',
    'フレックス勤務',
    '自社サービスを展開している',
    'スタートアップ',
    'リモート勤務可能',
    'グローバル展開している',
    'PHP',
    'Ruby',
    'エンジニアリング',
    '単価が安い順',
    '渋谷',
  ];
  private barIsOpen: boolean = false;
  private menuIsOpen: boolean = false;

  private saveTerms() {
    const terms: JobSearchTeam = {
      id: this.saveTerms.length + 1,
      searchTerms: this.searchTerms,
    };
    this.savedTerms.push(terms);
    this.barIsOpen = true;
  }
  private readTerms(index: number) {
    this.searchTerms = [...this.savedTerms[index].searchTerms];
  }
}
